<template>
    <ReceiptContainer>
        <RentalDetails/>
        <ChargeSummary/>
    </ReceiptContainer>
</template>

<script>
import ReceiptContainer from '@/components/global/ReceiptContainer.vue';
import RentalDetails from '@/components/rent/payment/RentalDetails.vue';
import ChargeSummary from '@/components/rent/shared/chargeSummary/ChargeSummary.vue';

export default {
    components: {
        ReceiptContainer,
        RentalDetails,
        ChargeSummary
    }
};
</script>
